// @ngInject
function stateConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('', '/');
    $urlRouterProvider.when('/', rootRedirect);
    $stateProvider.state('app', {
        abstract: true,
        url: '',
        templateUrl: 'app.tpl.html',
        data: { pageTitle: 'CleverApps'},
        resolve: {
            currentUser: userResolve
        }
    });
}

// @ngInject
function userResolve(AuthService) {
    return AuthService.getUser();
}

// @ngInject
function rootRedirect($state, AuthService) {
    if (!AuthService.hasToken()) {
        $state.transitionTo('login');
        return;
    }
    AuthService.getUser().then(function(user) {
        var hasSalesComparison = user.licenseConfig && user.licenseConfig.analysismodule &&
            localStorage.getItem('devFeature_salesComparisonReport') === 'true';
        $state.transitionTo(hasSalesComparison ? 'sales.reports' : 'main.dashboard');
    },function() {
        $state.transitionTo('login');
    });
}

angular
    .module('app', ['app.core','app.main','login', 'app.bridgeComponents'])
    .config(stateConfig);
